export const HEADERS = ['filename', 'market', 'product', 'template', 'actions'];
